const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    { Header: "id", accessor: "id", width: "20%" },
    { Header: "name", accessor: "name", width: "25%" },
    { Header: "description", accessor: "description", width: "35%" },
    { Header: "Actions", accessor: "actions", width: "25%" },
  ],

  rows: [],
};

export default dataTableData;
